import React from "react";
import "./Footer.scss";
import InstagramIcon from "../../assets/images/instagram-icon-white.svg";
import XIcon from "../../assets/images/x-icon-white.svg";

const Footer = () => {
  return (
    <div className="footer">
      <a
        href="https://www.instagram.com/lamovidaesta"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="footer__icon"
          src={InstagramIcon}
          alt="Icono Instagram"
        />
      </a>
      <a
        href="https://x.com/LaMovidaEsta"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="footer__icon" src={XIcon} alt="Icono X" />
      </a>
      <h3 className="footer__text">
        La Movida Esta Podcast© 2026 · By Jesús y{" "}
        <a
          href="https://www.macarenapaz.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__link"
        >
          Maka
        </a>
      </h3>
    </div>
  );
};

export default Footer;
